// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Background/news.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news_main_section__9psE- {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 70vh;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .news_heroSection__E27h6 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 5rem 0;
  }
}

.news_details_sec__o9Jse {
  max-width: 100%;
  margin: 0;
  padding: 0 0 3rem;
  background: linear-gradient(90deg, #ff5c00 0%, #7412dd 100%);
  background-size: cover;
  height: auto;

  .news_section__Fan6p {
    margin: 2rem 5.6rem;

    & h6 {
      width: 75%;
      color: var(--text-color);
      font-family: Inter;
      font-size: 2rem;
      font-weight: 700;
    }

    & p {
      padding-top: 10px;
      width: 90%;
      margin: 0;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.8rem;
      font-weight: 500;
    }
  }

  .news_btn_section__Bmg1d {
    display: flex;
    gap: 10px;
    margin: 1rem 0;

    & button {
      border-radius: 2px;
      width: auto;
      height: auto;
      background-color: #fefefe59;
      padding: 8px 0.8rem;
      border: none;
      margin: 0;
      color: #fff;
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 500;
    }
  }
}

.news_news_section__eng0S {
  padding: 0;
  margin: 2rem auto;

  & img {
    padding: 2rem 0;
    height: auto;
    max-width: 100%;
  }

  & p {
    padding-top: 1.2rem;
    font-family: Inter;
    font-size: 1rem;
    font-weight: 400;
    line-height: 19.37px;
  }
}

.news_downlaod_section__EY6S7 {
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & h6 {
    margin: 0;
    font-family: Inter;
    font-size: 1.2rem;
    font-weight: 700;
  }

  & p {
    font-family: Inter;
    font-size: 1rem;
    font-weight: 500;
  }

  & button {
    border: none;
    color: #ff5c00;
    font-family: Inter;
    font-size: 1rem;
    font-weight: 500;
    width: auto;
    height: 50px;
    padding: 10px 81px 10px 81px;
    gap: 10px;
    border-radius: 5px 0px 0px 0px;
    opacity: 0px;
  }
}

.news_overlay__TpJ0D {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}

/* --------media-queris----------- */

@media screen and (max-width: 568px) {
  .news_main_section__9psE- {
    height: auto;
  }

  .news_main_section__9psE- .news_heroSection__E27h6 {
    margin: 2rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/News/news.module.css"],"names":[],"mappings":"AAAA;EACE,yDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,4DAA4D;EAC5D,sBAAsB;EACtB,YAAY;;EAEZ;IACE,mBAAmB;;IAEnB;MACE,UAAU;MACV,wBAAwB;MACxB,kBAAkB;MAClB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,UAAU;MACV,SAAS;MACT,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,cAAc;;IAEd;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,2BAA2B;MAC3B,mBAAmB;MACnB,YAAY;MACZ,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;;EAEjB;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,SAAS;IACT,8BAA8B;IAC9B,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oCAAoC;;AAEpC;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/Background/news.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 70vh;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .heroSection {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    margin: 5rem 0;\n  }\n}\n\n.details_sec {\n  max-width: 100%;\n  margin: 0;\n  padding: 0 0 3rem;\n  background: linear-gradient(90deg, #ff5c00 0%, #7412dd 100%);\n  background-size: cover;\n  height: auto;\n\n  .section {\n    margin: 2rem 5.6rem;\n\n    & h6 {\n      width: 75%;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 2rem;\n      font-weight: 700;\n    }\n\n    & p {\n      padding-top: 10px;\n      width: 90%;\n      margin: 0;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-weight: 500;\n    }\n  }\n\n  .btn_section {\n    display: flex;\n    gap: 10px;\n    margin: 1rem 0;\n\n    & button {\n      border-radius: 2px;\n      width: auto;\n      height: auto;\n      background-color: #fefefe59;\n      padding: 8px 0.8rem;\n      border: none;\n      margin: 0;\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 500;\n    }\n  }\n}\n\n.news_section {\n  padding: 0;\n  margin: 2rem auto;\n\n  & img {\n    padding: 2rem 0;\n    height: auto;\n    max-width: 100%;\n  }\n\n  & p {\n    padding-top: 1.2rem;\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 19.37px;\n  }\n}\n\n.downlaod_section {\n  position: relative;\n  margin-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  & h6 {\n    margin: 0;\n    font-family: Inter;\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  & p {\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  & button {\n    border: none;\n    color: #ff5c00;\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 500;\n    width: auto;\n    height: 50px;\n    padding: 10px 81px 10px 81px;\n    gap: 10px;\n    border-radius: 5px 0px 0px 0px;\n    opacity: 0px;\n  }\n}\n\n.overlay {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n}\n\n/* --------media-queris----------- */\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    height: auto;\n  }\n\n  .main_section .heroSection {\n    margin: 2rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `news_main_section__9psE-`,
	"heroSection": `news_heroSection__E27h6`,
	"details_sec": `news_details_sec__o9Jse`,
	"section": `news_section__Fan6p`,
	"btn_section": `news_btn_section__Bmg1d`,
	"news_section": `news_news_section__eng0S`,
	"downlaod_section": `news_downlaod_section__EY6S7`,
	"overlay": `news_overlay__TpJ0D`
};
export default ___CSS_LOADER_EXPORT___;
